<template>
  <v-dialog v-model="dialog" persistent max-width="500px" @keydown.esc="close">
    <v-card>
      <div class="add_fa" style="height: 300px">
        <button class="close_bt" @click="close"></button>
        <span
          class="s_pop_title"
          style="font-size: 17pt; margin-bottom: 20px"
          >{{ editMeetingRoom.meetingRoomTitile }}</span
        >
        <input
          solo
          placeholder="회의실명"
          v-model="editMeetingRoom.editRoomName"
        />
        <div style="height: 10px"></div>
        <input
          solo
          placeholder="수용인원"
          v-model="editMeetingRoom.editCapacity"
        />
        <div class="danger-alert" v-if="error">
          {{ error }}
        </div>
        <div class="btnArea">
          <button type="submit" class="btnPrimary" @click="addMeetingRoom()">
            저장
          </button>
          <button type="submit" class="btn type3 reset" @click="close()">
            취소
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
export default {
  components: {},
  props: ['dialog', 'selectedBuilding', 'closeDialog'],
  data() {
    return {
      loading: true,
      error: null,
      defaultMeetingRoom: {
        meetingRoomTitile: '회의실 추가',
        roomId: null,
        editRoomName: null,
        editCapacity: null,
      },
      editMeetingRoom: {
        meetingRoomTitile: '회의실 추가',
        roomId: null,
        editRoomName: null,
        editCapacity: null,
      },
    };
  },
  watch: {
    dialog: {
      handler() {
        this.editMeetingRoom.editRoomName = '';
        this.editMeetingRoom.editCapacity = null;
      },
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    init() {
      this.error = null;
      this.editCorp = Object.assign({}, this.defaultCorp);
    },
    async addMeetingRoom() {
      /* 회의실추가 */
      let companyId = this.companyId;
      let bdId = this.selectedBuilding._id;
      let roomId = this.editMeetingRoom.roomId;
      let roomName = this.editMeetingRoom.editRoomName;
      let capacity = this.editMeetingRoom.editCapacity;
      let params = {
        companyId: companyId,
        buildingId: bdId,
        roomId: roomId,
        roomName: roomName,
        capacity: capacity,
      };

      await this.$http
        .post('/api/v1/rooms/addRoom', params)
        .then((response) => {
          if (response.data.ret === false) {
            alert(`${response.data.msg}`);
            return;
          }

          if (response.status === 200) {
            Util.snackBarOpen(
              this.$t('회의실 정보가 적용되었습니다.'),
              'primary'
            );
            this.init();
            this.closeDialog();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('중복된 회의실 정보가 있습니다.');
        });
    },
    close() {
      this.init();
      this.closeDialog();
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/admin/popup/RoomCreateDialog.vue